import { useLocation, useParams } from "react-router-dom";
import {  useState } from "react";
import { API_BASE_URL } from "../config/api";
import "../styles/ProductDetail.css";
import Navbar from "../components/Navbar";
import { MusicPreview, VideoPreview } from "../components/linkPreview";
import { useProductDetails } from "../hooks/useProductDetails";


export default function ProductDetail() {
  const { id } = useParams();
  const { state } = useLocation();
  const [product, setProduct] = useState(state?.product || null);


const {
  description,
  mainImage,
  loading,
  medias,
  currentIndex,
  nextImage,
  prevImage,
  handleThumbnailClick
} = useProductDetails(id, product);

  if (loading) 
    return <div className="loading">Chargement...</div>;

  if (!product)
    return <div className="error">Le produit n'a pas été trouvé </div>;

  return (
    <div className="detail-container">
      <div>
        <Navbar />
      </div>
      <div className="detail-content">
        <div className="detail-images">
          <div className="main-image-container">
            <img
              src={mainImage}
              alt={product.name}
              className="detail-main-image"
            />

            {medias.length > 1 && (
              <>
                <button className="retro-arrow left-arrow" onClick={prevImage}>
                  &lt;
                </button>
                <button className="retro-arrow right-arrow" onClick={nextImage}>
                  &gt;
                </button>
              </>
            )}
          </div>
          {medias.length > 0 && (
            <div className="detail-thumbnails-container">
              <div className="detail-thumbnails">
                {medias.map((media, index) => {
                  if (media.type === "image") {
                    return (
                      <img
                        key={index}
                        src={`${API_BASE_URL}/${media.path}`}
                        alt={`Thumbnail ${index + 1}`}
                        className={`detail-thumbnail ${index === currentIndex ? "active" : ""}`}
                        onClick={() => handleThumbnailClick(index)}
                      />
                    );
                  } else if (media.type === "video") {
                    return (
                      <VideoPreview
                        key={media.id}
                        onClick={() => handleThumbnailClick(index)}
                      />
                    );
                  } else if (media.type === "musique") {
                    return (
                      <MusicPreview
                        key={media.id}
                        onClick={() => handleThumbnailClick(index)}
                      />
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          )}
        </div>
        <div className="detail-info">
          <div id="cnt_title_prix">
            <h1 className="detail-title">{product.name}</h1>
            <div className="detail-price">{product.price} €</div>
          </div>
          
          <p className="detail-description">{description}</p>
          
        </div>
      </div>
    </div>
  );
}
